var React = require('react');
var ScreenWid = require('./stores/screen-wid-store');

module.exports = React.createClass({

  getInitialState: function() {
  	return { images: [] }
  },

  componentDidMount: function() {
  	this.getImages();
  },

  getImages: function() {
  	var endPoint = "https://api.instagram.com/v1/users/1641431160/media/recent?client_id=4a9d9f98dcec43dcac68916a2c1bb2ea&count=3";
      
    $.ajax({
      url: endPoint,
      jsonp: "callback",
      dataType: "jsonp",
 
      success: function( response ) {
        var images = response.data;

      	this.setState({images: [1, 2, 3].map(function(i) {
            //var index = Math.floor(Math.random() * images.length);
            //var img = images.splice(index, 1)[0];
            var img = images[i - 1];
            var className = 2 == i ? "top-img" : "";

            return <a href={img.link} target="_blank" className={className}
                      key={img.id} >
                <img src={img.images.low_resolution.url} title={img.caption ? img.caption.text : ""}/>
              </a>
      	    }.bind(this))});
            if("SM" == ScreenWid.width) {
                var viewportWidth = jQuery(window).width();
                var itemWidth = viewportWidth * 0.6;

                jQuery('.slides').flexslider({
                    selector: '#insta-imgs > a',
                    animation: 'slide',
                    slideshow: 0,
                    directionNav: false,
                    animationLoop: true,
                    itemWidth: itemWidth ,
                    startAt: 1
                 });
                var margin = viewportWidth * 0.2;
                var marginLeft = margin+15;
                var marginRight = margin-15;
                jQuery('.flex-viewport').css({'margin-left': marginLeft});
                jQuery('.flex-viewport').css({'margin-right': marginRight});
            }
        }.bind(this)
    });
  },

  render: function() {

  	return <section id="instagram">
            <div className="container fade-in">
                        <div id="instagram-inner">
                            <div className="row" id="instagram-content">
                                <div  className="col-sm-8">
                                    <div className="slides-container">
                                        <div className="slides">
                                            <div id="insta-imgs">

                                                {this.state.images}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="text-wrap col-sm-4">
                                    <h1 className="insta-hash">#StylishComfort</h1>
                                    <p>Here's how we get social on Instagram. Feel free to join us at <a href="https://instagram.com/ingledews/" target="_blank">@ingledews</a></p>
                                </div>
                            </div>
                        </div>
            </div>
        </section>
  }
});